// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio-module__radio___12x4Z","dot":"Radio-module__dot___1F3QK"};